var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesBranco03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n  .st0{ fill:currentColor; }\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.01,
    y: 8.47,
    className: "st0",
    width: 25.54,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.01,
    y: 0.39,
    className: "st0",
    width: 25.54,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.01,
    y: 16.55,
    className: "st0",
    width: 25.54,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,59.61H0.45V45.04c0-10.66,8.67-19.34,19.34-19.34s19.34,8.67,19.34,19.34v14.44h-2.96V45.04 c0-9.03-7.35-16.38-16.38-16.38S3.4,36.01,3.4,45.04V59.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.78,24.04c-5.71,0-10.35-4.64-10.35-10.35v-2.96c0-5.71,4.64-10.35,10.35-10.35s10.35,4.64,10.35,10.35 v2.96C30.13,19.4,25.49,24.04,19.78,24.04z M19.78,3.34c-4.08,0-7.39,3.32-7.39,7.39v2.96c0,4.08,3.31,7.39,7.39,7.39 s7.39-3.32,7.39-7.39v-2.96C27.18,6.66,23.86,3.34,19.78,3.34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.29,
    y: 41.18,
    className: "st0",
    width: 8.82,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.31,
    y: 35.56,
    className: "st0",
    width: 2.96,
    height: 22.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesBranco03);
export default __webpack_public_path__ + "static/media/Icones_Branco-03.60404aa849121d179b8f4b88a433c6dc.svg";
export { ForwardRef as ReactComponent };